import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleHashScroll = (hash: string) => {
    if (location.pathname !== "/") {
      navigate("/");
    }
    setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);
  };

  return (
    <footer className="bg-midnight border-t border-white/5">
      <div className="w-full px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <h3 className="text-marble font-serif text-xl tracking-wide mb-3">
              Maison Sound
            </h3>
            <p className="text-warmgray text-sm font-sans leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="text-marble/80 text-xs font-sans tracking-widest uppercase mb-4">
              {t("footer.column1.title")}
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => handleHashScroll("#instructors")}
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300 cursor-pointer"
                >
                  {t("footer.column1.link1")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleHashScroll("#curriculum")}
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300 cursor-pointer"
                >
                  {t("footer.column1.link2")}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-marble/80 text-xs font-sans tracking-widest uppercase mb-4">
              {t("footer.column2.title")}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/inquiry"
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300"
                >
                  {t("footer.column2.link1")}
                </Link>
              </li>
              {t("footer.column2.link2") && (
                <li>
                  <Link
                    to="/inquiry"
                    className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300"
                  >
                    {t("footer.column2.link2")}
                  </Link>
                </li>
              )}
              <li>
                <button
                  onClick={() => handleHashScroll("#pricing")}
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300 cursor-pointer"
                >
                  {t("footer.column2.link3")}
                </button>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300"
                >
                  {t("footer.column2.link4")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-marble/80 text-xs font-sans tracking-widest uppercase mb-4">
              {t("footer.column3.title")}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300"
                >
                  {t("footer.column3.link1")}
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-warmgray hover:text-marble text-sm font-sans transition-colors duration-300"
                >
                  {t("footer.column3.link2")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-warmgray/60 text-xs font-serif">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}